module.exports = __webpack_public_path__ + "img/UTJORD-7.af4fc262.jpg";